import React, { Component } from 'react';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import Select from '../../../../components/form/Select';
import DatePicker from '../../../../components/form/DateTime';
import Button from '../../../../components/form/Button';
import CroField from '../../components/generalForm/CroField';
import { styles } from '../../index';
import { asyncForm } from '../../../../utils/asyncForm';
import * as V from '../../../../utils/formValidation';

const severityItems = [
    { id: 'INFO', label: 'Informace' },
    { id: 'WARNING', label: 'Upozornění' },
    { id: 'CRITICAL', label: 'Kritické' },
];

const roleOptions = [
    { id: 'ROLE_ANONYMOUS', label: 'Nepřihlášení uživatelé' },
    { id: 'ROLE_PUBLIC', label: 'Žadatel o nahlížení' },
    { id: 'ROLE_OFFICIAL', label: 'Veřejný funkcionář' },
    { id: 'ROLE_OVM', label: 'Podpůrný orgán' },
    { id: 'ROLE_LEGITIMATE', label: 'Oprávněný orgán' },
    { id: 'ROLE_INTERNAL_ADMIN', label: 'Správce' },
    { id: 'ROLE_INTERNAL_OFFICIAL_ADMIN', label: 'Administrátor' },
    { id: 'ROLE_INTERNAL_JUDGE', label: 'Soudce' },
];

class InfoBannerForm extends Component {
    componentWillMount() {
        if (this.props.breadcrumbs && this.props.breadcrumbsItems) {
            this.props.breadcrumbs(this.props.breadcrumbsItems);
        }
    }

    handleSave = async (values) => {
        const targetRoles = roleOptions
            .filter(r => values[`role_${r.id}`])
            .map(r => r.id);

        if (targetRoles.length === 0) {
            throw new SubmissionError({ _error: 'Vyberte alespoň jednu roli' });
        }

        const toInstant = (d) => d ? new Date(d).toISOString() : null;

        const payload = {
            text: values.text,
            validFrom: toInstant(values.validFrom),
            validTo: toInstant(values.validTo),
            severity: values.severity || 'INFO',
            active: values.active !== undefined ? values.active : true,
            targetRoles,
        };
        if (values.id) {
            payload.id = values.id;
        }

        await this.props.onSubmit(payload);
    };

    render() {
        const { error, handleSubmit, submitting, onSaveTemplate, showSaveTemplate } = this.props;

        return (
            <form onSubmit={handleSubmit(this.handleSave)} className="cro-form in">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                    <tr>
                        <td style={{ verticalAlign: 'top', width: '55%', paddingRight: 30 }}>
                            <div style={{ marginBottom: 10 }}>
                                <span className="title required" style={{ fontSize: 12, color: '#6b7280' }}>Text upozornění</span>
                                <Field
                                    name="text"
                                    component="textarea"
                                    rows={10}
                                    style={{
                                        width: '100%',
                                        padding: '8px 14px',
                                        fontSize: 16,
                                        fontWeight: 600,
                                        fontFamily: 'inherit',
                                        border: '1px solid #b8c2cf',
                                        borderRadius: 4,
                                        resize: 'vertical',
                                        boxSizing: 'border-box',
                                    }}
                                    validate={[V.required]}
                                />
                            </div>
                        </td>
                        <td style={{ verticalAlign: 'top', paddingTop: 10 }}>
                            <div style={{ marginBottom: 8, fontWeight: 500, fontSize: 12, color: '#6b7280' }}>Zobrazit pro:</div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 30px' }}>
                                {roleOptions.map((role) => (
                                    <label key={role.id} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13, color: '#3b3b3b' }}>
                                        <Field name={`role_${role.id}`} component="input" type="checkbox" />
                                        {role.label}
                                    </label>
                                ))}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 15, marginTop: 15 }}>
                    <div style={{ flex: '0 0 150px' }}>
                        <CroField
                            title="Závažnost"
                            name="severity"
                            component={Select}
                            items={severityItems}
                            fullWidth
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <CroField
                            title="Platnost od"
                            name="validFrom"
                            component={DatePicker}
                            noIcon
                            dateOnly={false}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <CroField
                            title="Platnost do"
                            name="validTo"
                            component={DatePicker}
                            noIcon
                            dateOnly={false}
                        />
                    </div>
                    <Button
                        type="button"
                        style={styles.buttons}
                        label="Nastavit"
                        disabled={submitting}
                        onClick={handleSubmit(this.handleSave)}
                    />
                    {showSaveTemplate && (
                        <Button
                            type="button"
                            style={styles.buttons}
                            label="Uložit"
                            onClick={onSaveTemplate}
                        />
                    )}
                </div>

                {error && <div className="error" style={{ marginTop: 10 }}>{error}</div>}
            </form>
        );
    }
}

export default reduxForm({
    form: 'infoBannerForm',
})(asyncForm(InfoBannerForm));